import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import NewBusiness from './NewBusiness';
import ExistingBusiness from './ExistingBusiness';
import BusinessAdvertising from './BusinessAdvertising';
import Footer from '../../components/Footer';
import './BusinessPortal.css';

const BusinessPortal = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location.state?.tab || 'new');

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="business-portal">
        <h1 className="portal-heading">Business Portal</h1>

        <div className="portal-tabs">
          <button 
            className={`tab-button ${activeTab === 'new' ? 'active' : ''}`}
            onClick={() => setActiveTab('new')}
          >
            <i className="fas fa-store"></i>
            <span>New Business</span>
          </button>
          <button 
            className={`tab-button ${activeTab === 'existing' ? 'active' : ''}`}
            onClick={() => setActiveTab('existing')}
          >
            <i className="fas fa-edit"></i>
            <span>Existing Business</span>
          </button>
          <button 
            className={`tab-button ${activeTab === 'advertising' ? 'active' : ''}`}
            onClick={() => setActiveTab('advertising')}
          >
            <i className="fas fa-ad"></i>
            <span>Advertising</span>
          </button>
        </div>

        <div className="portal-content">
          {activeTab === 'new' && <NewBusiness />}
          {activeTab === 'existing' && <ExistingBusiness />}
          {activeTab === 'advertising' && <BusinessAdvertising />}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BusinessPortal; 